/* eslint-disable react/no-unknown-property */
import {
  HStack, Icon, ICON_EMAIL_OUTLINE, Link, Popover, PopoverProps, Text,
} from '@doveit/bricks';
import React from 'react';
import { User } from '@auth0/auth0-spa-js';
import PopoverPreview from '../../../components/popover-preview/PopoverPreview';
import UserAvatar from '../user-avatar/UserAvatar';
import * as styles from './UserPopoverPreview.style';

export interface UserPopoverPreviewProps extends React.AriaAttributes {
  user?: Pick<User, 'name' | 'email'>,
  trigger: PopoverProps['trigger'],
  namePlaceholder?: string,
}

const UserPopoverPreview: React.FC<UserPopoverPreviewProps> = ({
  user,
  trigger,
  namePlaceholder = 'Utente',
  ...rest
}) => (
  <Popover
    trigger={trigger}
    hasArrow
    {...rest}
  >
    <div css={styles.wrapper}>
      <PopoverPreview
        aria-label="Informazioni utente"
        title={user?.name || namePlaceholder}
        avatar={(
          <UserAvatar size="L" />
        )}
      >
        {user?.email && (
          <HStack wrap="nowrap" gap={75}>
            <Icon path={ICON_EMAIL_OUTLINE} size={20} />
            <Text.Body>
              <Link href={`mailto:${user.email}`}>
                {user.email}
              </Link>
            </Text.Body>
          </HStack>
        )}
      </PopoverPreview>
    </div>
  </Popover>
);

export default UserPopoverPreview;
